if (document.querySelector('.lang__dropdown')) {
    const lang = document.querySelector('.lang');
    const langBtn = document.querySelector('.lang__button');
    const langDropdown = document.querySelector('.lang__dropdown');
    const langUl = document.querySelector('.lang__ul');
    const langWrap = document.querySelector('.lang__wrap');

    const lang2 = document.querySelector('.lang--desktop');
    const langBtn2 = lang2.querySelector('.lang__button');
    const langDropdown2 = lang2.querySelector('.lang__dropdown');
    const langUl2 = lang2.querySelector('.lang__ul');
    const langWrap2 = lang2.querySelector('.lang__wrap');
    
    const updateHeight = () => {
        if (langDropdown.getAttribute('data-expanded') == 'true' && $screenWidth < 1280) {
            const updatedHeight = langUl.clientHeight;
            langWrap.style.height = updatedHeight + "px";
        }
    }
    
    const toggleLangListMobile = () => {
        if ($screenWidth < 1280) {
            if (langDropdown.getAttribute('data-expanded') == 'false') {
                langWrap.style.height = langUl.clientHeight + "px";
                langDropdown.setAttribute('data-expanded', 'true');
            } else {
                langWrap.removeAttribute('style');
                langDropdown.setAttribute('data-expanded', 'false');
            }
        }
    }
    
    const desktopDropdown = () => {
        if ($screenWidth >= 1280) {
            langDropdown.setAttribute('data-expanded', 'false');
            langWrap.removeAttribute('style');
        }
    }
    
    const hoverLangListDesktop = () => {
        if ($screenWidth >= 1280) {
            // console.log('test');
            if (langDropdown.getAttribute('data-expanded') == 'false') {
                langWrap2.style.height = langUl2.clientHeight + "px";
                langDropdown2.setAttribute('data-expanded', 'true');
            } else {
                langWrap2.removeAttribute('style');
                langDropdown2.setAttribute('data-expanded', 'false');
            }
        }
    }

    const endHoverLangListDesktop = () => {
        if ($screenWidth >= 1280) {
            langWrap2.removeAttribute('style');
            langDropdown2.setAttribute('data-expanded', 'false');
        }
    }
    
    langBtn.addEventListener('click', toggleLangListMobile);
    window.addEventListener('resize', updateHeight);
    window.addEventListener('resize', desktopDropdown);
    lang2.addEventListener('mouseover', hoverLangListDesktop);
    lang2.addEventListener('mouseout', endHoverLangListDesktop);
    // lang.addEventListener('mouseover', seeDesktopDropdown);
    // lang.addEventListener('mouseout', unseeDesktopDropdown);
}